module.exports = __webpack_public_path__ + "static/media/no_order.15e23084.png";